"use strict";
import get from "../data/get";
import ReactUtils from "../../react_utils";
import generalFormatter from "../../formatters/general";
import DropSelector from "./drop_selector";
import TmsDeletedWarningIcon from "../load_tms_deleted_warning";
var bem = ReactUtils.makeBem("document-browser");
export default React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement(
      DropSelector,
      {
        tmsObjects: this.props.tmsDeliveries,
        tmsObjectDetailsFunction: this.delivery,
        label: "Choose a drop (that this is POD for):"
      }
    );
  },
  delivery: function(tmsDelivery, i) {
    var entry = {
      tms_delivery_id: tmsDelivery.id,
      document_id: this.props.document.id
    };
    var deliveryDocuments = this.props.carrierInvoice.delivery_documents;
    var tmsShipment = get.tmsShipment(tmsDelivery);
    var tmsStop = get.tmsStop(tmsDelivery);
    let customerNameText;
    if (!_.isEmpty(tmsShipment.customer)) {
      customerNameText = " for " + tmsShipment.customer.name;
    }
    let isChecked = _.findWhere(deliveryDocuments, entry);
    let isDisabled = !isChecked && _.findWhere(deliveryDocuments, {
      tms_delivery_id: tmsDelivery.id
    });
    let onChange = _.partial(
      this.props.toggleDeliveryDocument,
      this.props.carrierInvoice,
      tmsDelivery,
      this.props.document
    );
    let addressParts = [
      tmsStop.address_line_1,
      tmsStop.address_line_2,
      tmsStop.city
    ];
    let address = _.compact(addressParts).join(", ");
    let weight = generalFormatter.weight(tmsShipment.weight);
    let cssClasses = bem({
      "__assign-documents-selector-item-label": true,
      "__assign-documents-selector-item-label--disabled": isDisabled
    });
    let tmsDeletedIcon;
    if (tmsStop.tms_deleted) {
      tmsDeletedIcon = /* @__PURE__ */ React.createElement(TmsDeletedWarningIcon, null);
    }
    return /* @__PURE__ */ React.createElement("div", { key: "delivery-" + i }, /* @__PURE__ */ React.createElement("label", { className: cssClasses }, i + 1 + ")", "\xA0", /* @__PURE__ */ React.createElement(
      "input",
      {
        className: bem("__assign-documents-selector-checkbox"),
        checked: isChecked,
        onChange,
        type: "checkbox"
      }
    ), tmsShipment.shipment_id, " ", customerNameText, " @ ", address, " ", weight, tmsDeletedIcon));
  }
});
